import Raven from 'raven-js';
import { sanitizeWithConfig } from './sanitizeConfig';
import { secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';
const logMalformedHtml = (id, locale, content) => {
  Raven.captureMessage(`The HTML content of the Product Update #${id} is malformed in locale ${locale}`, {
    extra: {
      id,
      locale,
      content,
      context: 'For recently added product updates (<3mo) reach out to #product-l10n otherwise reach out to #product-i18n.'
    }
  });
};
const createHtmlElement = (content, productUpdateId, locale) => {
  const sanitizedHtml = sanitizeWithConfig(content);
  const element = secureDocument.createElement('html');
  element.innerHTML = sanitizedHtml;
  const elements = element.getElementsByClassName('product-update-v2');
  if (elements.length === 0) {
    logMalformedHtml(productUpdateId, locale, content);
    return null;
  }
  return elements[0];
};
export const getBodyHtml = (contentHtml, productUpdateId, locale) => {
  const html = createHtmlElement(contentHtml, productUpdateId, locale);
  if (!html) {
    return contentHtml;
  }
  const updateContent = html.getElementsByClassName('update-content');
  if (updateContent.length === 0 || !(updateContent[0] instanceof HTMLElement)) {
    logMalformedHtml(productUpdateId, locale, contentHtml);
    return contentHtml;
  }
  return updateContent[0].innerHTML;
};
export const getHeroImageUrl = (contentHtml, productUpdateId, locale) => {
  const html = createHtmlElement(contentHtml, productUpdateId, locale);
  const image = html && html.querySelector('.product-update-v2 > a > img, .product-update-v2 > img');
  return image && image.src;
};